import { AlignLeft } from '../../utils/editorReactIcons';
export { AlignLeft };
export default AlignLeft;
